import classNames from 'classnames';
import React from 'react';
import Markdown from 'react-markdown';

import {
	BarryChart,
	type VisualizationData,
} from '~components/business-owner/barry/chart/BarryChart';

import styles from './BarryIndividualConversation.module.scss';

interface BarryUserMessageBubbleProps {
	content: string;
	visualization?: VisualizationData;
}

export const BarryUserMessageBubble: React.FC<BarryUserMessageBubbleProps> = (props) => {
	const { content, visualization } = props;

	return (
		<div className={classNames(styles.messageRow, styles.user)}>
			<div className={styles.messageBubble}>
				<Markdown>{content}</Markdown>
				{visualization && <BarryChart visualization={visualization} />}
			</div>
		</div>
	);
};
